var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"losing--gif--container",attrs:{"id":"losing--grid"}},[_c('div',{staticClass:"losing_img",class:{
			'losing-image-kids': _vm.gameMode === 'kids',
			'losing-image-adults': _vm.gameMode === 'adults',
		}})])
}
var staticRenderFns = []

export { render, staticRenderFns }